export class TempResponseDto {
  todaytemp: number=30;
  todayHum: number=30;
  todayPrecip: number=30;
  todayWind: number=30;
  todayImg:string=''
}
